import client from '../client';

export async function getOutput(deploymentId, taskId) {
  return client.get(`/mtms/api/v1/deployments/${deploymentId}/tasks/${taskId}/output`);
}
